import { PROJECTS_GET_DETAILS, PROJECTS_GET_MEANS_TREE, PROJECTS_GET_PERIOD_GRAPH, PROJECTS_GET_SUMMARY, PROJECTS_GET_TREE_FR, PROJECTS_GET_TREE_DE, PROJECTS_GET_TREE_PC, PROVIDERS_GET_COMPANIES, PROVIDERS_GET_DIMENSIONS, PROVIDERS_GET_ORIGINS, PROVIDERS_GET_PERIODS, PROVIDERS_GET_PROJECTS, PROVIDERS_GET_PROVIDERS, PROVIDERS_GET_PROVIDERS_DETAILS, PROVIDERS_GET_STATUS, TO_PAY_PERIOD_DELAY_DATA, TO_PAY_PERIOD_DELAY_DETAILS_DATA, TO_PAY_PERIOD_DELAY_PROVIDER_DETAILS_DATA, TO_PAY_PERIOD_DELAY_PROVIDERS_DATA, PROJECTS_CLASSIFICATION_GET_PERIOD_GRAPH, PROJECTS_CLASSIFICATION_GET_DETAILS, PROJECTS_CLASSIFICATION_GET_SUMMARY, PROJECTS_MEANS_GET_DETAILS, PROJECTS_MEANS_GET_PERIOD_GRAPH, PROJECTS_MEANS_GET_SUMMARY, PROJECTS_GET_MONTHLY_DET, PROJECTS_GET_MONTHLY_RES, PROJECTS_GET_DATES, PROFIT_GET_COMPANIES, PROFIT_GET_PROJECTS, PROFIT_GET_PERIODS, PROFIT_GET_PROFIT, PROFIT_GET_PC, PROFIT_GET_COINS, BOARD_PROCESS_STATUS, BOARD_PROCESS_EXECUTE } from "../constants/signalRequestConsts";
import { BOARD_PROCESS_EXECUTE_SP, BOARD_PROCESS_STATUS_SP } from "../constants/boardProcessConsts";

import { store } from "../store";
import { refreshToken } from "../store/slices/auth";
import { ViewType } from "../views/delay-dashboard";

const handleResponse = async (response: any, originalRequest: any) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => null);

    if (errorData?.message === "No se encontraron clientes activos para la conexión") {
      const oldToken = originalRequest.headers.get('Token');
      console.log("retrying, old token: " + oldToken);

      refreshToken(oldToken);

      await new Promise(resolve => setTimeout(resolve, 1));

      const authState = store.getState().auth;

      if (oldToken === authState?.token) {
        console.log("retry has failed");
        // store.dispatch(logout());
        throw new Error('Token refresh failed');
      }

      console.log("retry has worked: " + authState?.token);

      const newRequest = {
        ...originalRequest,
        headers: {
          ...originalRequest.headers,
          'Authorization': `Bearer ${authState?.token}`,
          'Token': authState?.token
        }
      };

      return fetch(newRequest.url, newRequest);
    }

    throw new Error(errorData?.message || 'Request failed');
  }

  return response;
};

const fetchWithInterceptor = async (url: string, options: any = {}) => {
  try {
    const response = await fetch(url, options);
    return await handleResponse(response, { url, ...options });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const signalGenericRequest = async (requestId: string, request: string, HasOutputParam = false) => {
  const authState = store.getState().auth;

  if (!authState?.token) {
    console.warn('Token no encontrado en el store. No se puede realizar la petición.');
    return { status: 400, data: { isSuccess: false } };
  }

  const body = {
    HasOutputParam,
    ObjectName: request,
    RequestId: requestId,
    SignalRConnectionID: localStorage.getItem("connectionId"),
  };

  const headers = {
    'Content-Type': 'application/json',
    'Token': authState.token,
    'ModuleId': authState.moduleId,
  };

  try {
    const response = await fetchWithInterceptor(
      `${process.env.REACT_APP_SIGNALR_URL}/api/S10ERP/RequestS10ERPData`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      }
    );

    const result = await response.json();

    if (!response.ok || !result?.isSuccess) {
      console.log(result);
      if (result?.message === "No se encontraron clientes activos para la conexión") {
        // window.location.reload();
      }
      return { status: response.status, data: result };
    }

    return { status: response.status, data: result };
  } catch (error) {
    console.log(error);
    return { status: 400, data: { isSuccess: false } };
  }
};

export const signalGenericTransportDataRequest = async (requestId: string, request: string, HasOutputParam = false) => {
  const authState = store.getState().auth;

  if (!authState?.token) {
    console.warn('Token no encontrado en el store. No se puede realizar la petición.');
    return { status: 400, data: { isSuccess: false } };
  }

  const body = {
    HasOutputParam,
    ObjectName: request,
    RequestId: requestId,
    SignalRConnectionID: authState.connectionId,
    SecurityUserId: authState?.userId,
    AdditionalValues: '',
    MultipleObject: false,
  };

  const headers = {
    'Content-Type': 'application/json',
    'Token': authState.token,
    'ModuleId': process.env.REACT_APP_MODULE_ID,
  };

  try {
    const response = await fetchWithInterceptor(
      `${process.env.REACT_APP_SIGNALR_URL}/api/S10ERP/RequestS10ERPTransportData`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      }
    );

    const result = await response.json();

    if (!response.ok || !result?.isSuccess) {
      console.log(result);
      if (result?.message === "No se encontraron clientes activos para la conexión") {
        // window.location.reload();
      }
      return { status: response.status, data: result };
    }

    return { status: response.status, data: result };
  } catch (error) {
    console.log(error);
    return { status: 400, data: { isSuccess: false } };
  }
};

const getFinalStringValue = (value: string) => !value || value === 'all' ? '' : value

export const requestSignalCompaniesData = async () => {
  return await signalGenericRequest(PROVIDERS_GET_COMPANIES, 'dbo.S10_12_BI_EmpresaDP_Listar');
};

export const requestSignalProjectsData = async (codCompany: string) => {
  return await signalGenericRequest(PROVIDERS_GET_PROJECTS, `dbo.S10_12_BI_ProyectoDP_ListarPorEmpresa '${getFinalStringValue(codCompany)}'`);
};

export const requestSignalDimensionData = async (codCompany: string, mode: string) => {
  return await signalGenericRequest(PROVIDERS_GET_DIMENSIONS, `dbo.S10_12_BI_ProyectoVectorDP_ListarPorEmpresa '${getFinalStringValue(codCompany)}','${mode}'`);
};

export const requestSignalPeriodsData = async (codCompany: string, codProject: string) => {
  return await signalGenericRequest(PROVIDERS_GET_PERIODS, `dbo.S10_12_BI_PeriodoContableDP_ListarPorEmpresaProyecto '${getFinalStringValue(codCompany)}','${getFinalStringValue(codProject)}'`);
};

export const requestSignalOriginData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string) => {
  return await signalGenericRequest(PROVIDERS_GET_ORIGINS, `dbo.S10_12_BI_RDocumento_Proveedor_ListarOrigen '${getFinalStringValue(codCompany)}','${getFinalStringValue(codProject)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}'`);
};

export const requestSignalStatusData = async (codCompany: string, codProject: string, codPeriod: string) => {
  return await signalGenericRequest(PROVIDERS_GET_STATUS, `dbo.S10_12_BI_RDocumento_Proveedor_ListarEstado '${getFinalStringValue(codCompany)}','${getFinalStringValue(codProject)}','${getFinalStringValue(codPeriod)}'`);
};

export const requestSignalCompaniesToPayData = async () => {
  return await signalGenericRequest(PROVIDERS_GET_COMPANIES, 'dbo.S10_12_BI_SDP_Empresa_Listar');
};

export const requestSignalProjectsToPayData = async (codCompany: string, view: ViewType) => {
  return await signalGenericRequest(PROVIDERS_GET_PROJECTS, `dbo.S10_12_BI_SDP_Proyecto_Listar '${getFinalStringValue(codCompany)}',${view}`);
};

export const requestSignalDimensionToPayData = async (codCompany: string, mode: string, view: ViewType) => {
  return await signalGenericRequest(PROVIDERS_GET_DIMENSIONS, `dbo.S10_12_BI_SDP_ProyectoDimension_Listar '${getFinalStringValue(codCompany)}','${mode}',${view}`);
};

export const requestSignalPeriodsToPayData = async (codCompany: string, codProject: string, view: ViewType) => {
  return await signalGenericRequest(PROVIDERS_GET_PERIODS, `dbo.S10_12_BI_SDP_PeriodoContable_Listar '${getFinalStringValue(codCompany)}','${getFinalStringValue(codProject)}',${view}`);
};

export const requestSignalOriginToPayData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string, view: ViewType) => {
  return await signalGenericRequest(PROVIDERS_GET_ORIGINS, `dbo.S10_12_BI_SDP_Documento_ListarOrigen '${getFinalStringValue(codCompany)}','${getFinalStringValue(codProject)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}',${view}`);
};

export const requestSignalStatusToPayData = async (codCompany: string, codProject: string, codPeriod: string, view: ViewType) => {
  return await signalGenericRequest(PROVIDERS_GET_STATUS, `dbo.S10_12_BI_SDP_Documento_ListarEstado '${getFinalStringValue(codCompany)}','${getFinalStringValue(codProject)}','${getFinalStringValue(codPeriod)}',${view}`);
};

export const requestSignalPeriodsDelayToPayData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string, codOrigin: string, mode: string, view: ViewType, quantityPerPage: string, searchText: string) => {
  let finalMode = ''
  let finalProject = codProject
  let finalDimension = ''
  if (mode !== 'Proyecto') {
    finalMode = mode;
    finalProject = '';
    finalDimension = codProject
  }
  return await signalGenericRequest(TO_PAY_PERIOD_DELAY_DATA, `dbo.S10_12_BI_SDP_Documento_ListarPeriodoRetraso '${getFinalStringValue(codCompany)}','${getFinalStringValue(finalProject)}','${getFinalStringValue(finalMode)}','${getFinalStringValue(finalDimension)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}','${getFinalStringValue(codOrigin)}',${view}`, true);
};

export const requestSignalPeriodsDelayDetailsToPayData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string, codOrigin: string, mode: string, codPeriodDelay: string, rangeCode: string, view: ViewType, quantityPerPage: string, searchText: string) => {
  let finalMode = ''
  let finalProject = codProject
  let finalDimension = ''
  if (mode !== 'Proyecto') {
    finalMode = mode;
    finalProject = '';
    finalDimension = codProject
  }
  return await signalGenericRequest(TO_PAY_PERIOD_DELAY_DETAILS_DATA, `dbo.S10_12_BI_SDP_DocumentoRetraso_ListarPorPeriodo '${getFinalStringValue(codCompany)}','${getFinalStringValue(finalProject)}','${getFinalStringValue(finalMode)}','${getFinalStringValue(finalDimension)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}','${getFinalStringValue(codOrigin)}','${getFinalStringValue(codPeriodDelay)}',${rangeCode},${view}`);
};


export const requestSignalPeriodsDelayProvidersToPayData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string, codOrigin: string, mode: string, codPeriodDelay: string, view: ViewType, quantityPerPage: string, searchText: string) => {
  let finalMode = ''
  let finalProject = codProject
  let finalDimension = ''
  if (mode !== 'Proyecto') {
    finalMode = mode;
    finalProject = '';
    finalDimension = codProject
  }
  return await signalGenericRequest(TO_PAY_PERIOD_DELAY_PROVIDERS_DATA, `dbo.S10_12_BI_SDP_Documentoretraso_ListarPorProveedor '${getFinalStringValue(codCompany)}','${getFinalStringValue(finalProject)}','${getFinalStringValue(finalMode)}','${getFinalStringValue(finalDimension)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}','${getFinalStringValue(codOrigin)}','${getFinalStringValue(codPeriodDelay)}',${view}`);
};


export const requestSignalPeriodsDelayProviderDetailsToPayData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string, codOrigin: string, mode: string, codPeriodDelay: string, providerCode: string, rangeCode: string, view: ViewType, quantityPerPage: string, searchText: string) => {
  let finalMode = ''
  let finalProject = codProject
  let finalDimension = ''
  if (mode !== 'Proyecto') {
    finalMode = mode;
    finalProject = '';
    finalDimension = codProject
  }
  return await signalGenericRequest(TO_PAY_PERIOD_DELAY_PROVIDER_DETAILS_DATA, `dbo.S10_12_BI_SDP_DocumentoRetraso_ListarPorProveedorPeriodo '${getFinalStringValue(codCompany)}','${getFinalStringValue(finalProject)}','${getFinalStringValue(finalMode)}','${getFinalStringValue(finalDimension)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}','${getFinalStringValue(codOrigin)}','${getFinalStringValue(codPeriodDelay)}','${getFinalStringValue(providerCode)}',${rangeCode},${view}`);
};

export const requestSignalProvidersData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string, codOrigin: string, mode: string, quantityPerPage: string, searchText: string) => {
  let finalMode = ''
  let finalProject = codProject
  let finalDimension = ''
  if (mode !== 'Proyecto') {
    finalMode = mode;
    finalProject = '';
    finalDimension = codProject
  }
  return await signalGenericRequest(PROVIDERS_GET_PROVIDERS, `dbo.S10_12_BI_RDocumento_Proveedor_Listar '${getFinalStringValue(codCompany)}','${getFinalStringValue(finalProject)}','${getFinalStringValue(finalMode)}','${getFinalStringValue(finalDimension)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}','${getFinalStringValue(codOrigin)}','${searchText}',${quantityPerPage},1`, true);
};

export const requestSignalProviderDetailsData = async (codCompany: string, codProject: string, codPeriod: string, codStatus: string, codOrigin: string, codProvider: string, mode: string, quantityPerPage: string) => {
  let finalMode = ''
  let finalProject = codProject
  let finalDimension = ''
  if (mode !== 'Proyecto') {
    finalMode = mode;
    finalProject = '';
    finalDimension = codProject
  }
  return await signalGenericRequest(PROVIDERS_GET_PROVIDERS_DETAILS
    , `dbo.S10_12_BI_RDocumento_Proveedor_Detalle_Listar '${getFinalStringValue(codCompany)}','${getFinalStringValue(finalProject)}','${getFinalStringValue(finalMode)}','${getFinalStringValue(finalDimension)}','${getFinalStringValue(codPeriod)}','${getFinalStringValue(codStatus)}','${getFinalStringValue(codOrigin)}','${getFinalStringValue(codProvider)}',${quantityPerPage},1`, true);
};






// projectos (RO)
export const requestSignalPartyControlTreePC = async (codPcUrl: string) => {
  return await signalGenericRequest(
    PROJECTS_GET_TREE_PC,
    `dbo.S10_06_TipoClcasificacion_Listar '${codPcUrl}', '01'`
  );
};

export const requestSignalPartyControlTreeFT = async (codPcUrl: string) => {
  return await signalGenericRequest(
    PROJECTS_GET_TREE_DE,
    `dbo.S10_06_TipoClcasificacion_Listar '${codPcUrl}', '04'`
  );
};

export const requestSignalPartyControlTreeFR = async (codPcUrl: string) => {
  return await signalGenericRequest(
    PROJECTS_GET_TREE_FR,
    `dbo.S10_06_TipoClcasificacion_Listar '${codPcUrl}', '05'`
  );
};

export const requestSignalProjectDates = async (idCod: string, scale: '0' | '1' | '2') => {
  return await signalGenericRequest(
    PROJECTS_GET_DATES,
    `dbo.S10_06_BI_ProyectoCalendario_Listar '${idCod}', '${scale}'`
  );
};

export const requestSignalProjectDetails = async (idCod: string, date: string, scale: '0' | '1' | '2') => {
  return await signalGenericRequest(
    PROJECTS_GET_DETAILS,
    `dbo.S10_06_Tablero_ListarProyectoDetalle '${idCod}', '01', '', '${date}', ${scale}`
  );
};

export const requestSignalProjectSummary = async (idCod: string, date: string, scale: '0' | '1' | '2') => {
  return await signalGenericRequest(
    PROJECTS_GET_SUMMARY,
    `dbo.S10_06_TableroProyecto10_Listar '01', '${idCod}', '${date}', ${scale}`
  );
};

export const requestSignalProjectPeriodGraph = async (idCod: string, date: string, accumulated: 0 | 1, scale: '0' | '1' | '2') => {
  const stored = accumulated
    ? 'S10_00_ResultadoOperativo_ListarPorPeriodo'
    : 'S10_00_ResultadoOperativoGrafico_ListarPorPeriodo'
  return await signalGenericRequest(
    PROJECTS_GET_PERIOD_GRAPH,
    `dbo.${stored} '${idCod}', '01', '', '${date}', ${scale}`
  );
}

export const requestSignalProjectPeriodGraphDetails = async (idCod: string, type: string, head: string, date: string, accumulated: 0 | 1, scale: '0' | '1' | '2') => {
  const request = accumulated
    ? `dbo.S10_00_ResultadoOperativo_ListarPorPeriodoDetalle '${idCod}', '${type}', '', '${head}', '${date}', ${scale}`
    : `dbo.S10_00_ResultadoOperativoGrafico_ListarPorPeriodoDetalle '${idCod}', '${type}', '', '${head}', '${date}', ${scale}`
  return await signalGenericRequest(
    PROJECTS_GET_PERIOD_GRAPH,
    request
  );
}

export const requestSignalProjectClassificationDetails = async (idCod: string, type: string, idClass: string, date: string, scale: '0' | '1' | '2') => {
  return await signalGenericRequest(
    PROJECTS_CLASSIFICATION_GET_DETAILS,
    `dbo.S10_06_Tablero_ListarProyectoDetalle '${idCod}', '${type}', '${idClass}', '${date}', ${scale}`
  );
}

export const requestSignalProjectClassificationPeriodGraph = async (idCod: string, type: string, idClass: string, date: string, accumulated: 1 | 0, scale: '0' | '1' | '2') => {
  const stored = accumulated
    ? 'S10_00_ResultadoOperativo_ListarPorPeriodo'
    : 'S10_00_ResultadoOperativoGrafico_ListarPorPeriodo'
  return await signalGenericRequest(
    PROJECTS_CLASSIFICATION_GET_PERIOD_GRAPH,
    `dbo.${stored} '${idCod}', '${type}', '${idClass}', '${date}', ${scale}`
  );
}

export const requestSignalProjectClassificationPeriodGraphDetails = async (idCod: string, type: string, idClass: string, headCode: string, date: string, accumulated: 1 | 0, scale: '0' | '1' | '2') => {
  
  const request = accumulated
    ? `dbo.S10_00_ResultadoOperativo_ListarPorPeriodoDetalle '${idCod}', '${type}', '${idClass}', '${headCode}', '${date}', ${scale}`
    : `dbo.S10_00_ResultadoOperativoGrafico_ListarPorPeriodoDetalle '${idCod}', '${type}', '${idClass}', '${headCode}', '${date}', ${scale}`
  return await signalGenericRequest(
    PROJECTS_CLASSIFICATION_GET_PERIOD_GRAPH,
    request,
  );
}

export const requestSignalProjectClassificationSummary = async (idCod: string, type: string, idClass: string, date: string, scale: '0' | '1' | '2') => {
  return await signalGenericRequest(
    PROJECTS_CLASSIFICATION_GET_SUMMARY,
    `dbo.S10_06_Tablero_PartidaControlListar '${idCod}', '${type}', '${idClass}', '${date}', ${scale}`
  );
}

export const requestSignalMeansTree = async (idCod: string, type: string, idClass: string, date: string) => {

  return await signalGenericRequest(
    PROJECTS_GET_MEANS_TREE,
    `dbo.S10_06_TipoClcasificacion_ListarRecurso '${idCod}', '${type}', '${idClass}', '${date}'`
  );
};




export const requestSignalProjectMeansDetails = async (idCod: string, type: string, idClass: string, idResource: string, date: string, scale: '0' | '1' | '2') => {
  /*
  @CodProyecto	VARCHAR(20),
	@Tipo			Varchar(2) = '01',
	@CodPeriodo		Varchar(6),
	@CodPC			VARCHAR(60) = '',
	@CodRecurso		Varchar(14) = '',
	@Escala			Tinyint	= 0 -- 0 = Mensual, 1 = Semana, 2 = Año
  */
  return await signalGenericRequest(
    PROJECTS_MEANS_GET_DETAILS,
    `dbo.S10_06_TableroRecurso_Listar10 '${idCod}', '${type}', '${date}', '${idClass}', '${idResource}', ${scale}`
  );
}

export const requestSignalProjectMeansPeriodGraph = async (idCod: string, type: string, idClass: string, idResource: string, accumulated: 1 | 0, date: string, scale: '0' | '1' | '2') => {
  /*
  @CodProyecto		VARCHAR(60),
	@Tipo				VARCHAR(2) = '01',
	@CodClasificacion	VARCHAR(60) = '',
	@CodInsumo			VARCHAR(14) = '',
	@Acumulado			TinyInt = 1,
	@CodPeriodo			Varchar(6) = '',
	@Escala				Tinyint	= 0 -- 0 = Mensual, 1 = Semana, 2 = Año
  */
  return await signalGenericRequest(
    PROJECTS_MEANS_GET_PERIOD_GRAPH,
    `dbo.S10_06_TableroRecursoGrafico_Listar10 '${idCod}', '${type}', '${idClass}', '${idResource}', '${accumulated}', '${date}', ${scale}`
  );
}

export const requestSignalProjectMeansPeriodGraphDetails = async (idCod: string, type: string, idClass: string, headCode: string, date: string, scale: '0' | '1' | '2') => {
  return await signalGenericRequest(
    PROJECTS_MEANS_GET_PERIOD_GRAPH,
    `dbo.S10_00_ResultadoOperativo_ListarPorPeriodoDetalle '${idCod}', '${type}', '${idClass}', '${headCode}', '${date}', ${scale}`
  );
}

export const requestSignalProjectMeansSummary = async (idCod: string, type: string, idClass: string, idResource: string, date: string, scale: '0' | '1' | '2', accumulated: number) => {
  /*
  	@CodProyecto	VARCHAR(60),
    @Tipo			Varchar(2) = '01',
    @CodPeriodo		Varchar(6),
    @CodPC			VARCHAR(60) = '',
    @CodInsumo		VARCHAR(14) = '',
    @Acumulado		Bit = 1,
    @Escala			Tinyint	= 0 -- 0 = Mensual, 1 = Semana, 2 = Año

  */
  return await signalGenericRequest(
    PROJECTS_MEANS_GET_SUMMARY,
    `dbo.S10_06_Tablero_ListarTipoRecurso '${idCod}', '${type}', '${date}', '${idClass}', '${idResource}', 1, ${scale}`
  );
}

export const requestSignalProjectMonthlyDetail = async (idCod: string, type: string, codIdentificador: string, head: string, itemsPerPage: number, pageNumber: number, date: string, scale: '0' | '1' | '2') => {
  const finalIdCod = getFinalStringValue(idCod);
  const finalType = getFinalStringValue(type);
  const finalCodIdentificador = getFinalStringValue(codIdentificador);

  return await signalGenericRequest(
    PROJECTS_GET_MONTHLY_DET,
    `dbo.S10_06_Tablero_ListarProyectoMensualDetalle '${finalIdCod}', '${finalType}', '${finalCodIdentificador}', '${head}', '${date}', ${scale}, ${itemsPerPage}, ${pageNumber}`,
    true
  );
}

export const requestSignalProjectMonthlyResources = async (idCod: string, type: string, date: string, codPc: string, head: string, itemsPerPage: number, pageNumber: number, accumulated: number, searchText: string = '', scale: '0' | '1' | '2') => {
  const finalSearch = searchText || '';
  /*
  	@CodProyecto	VARCHAR(8),
    @Tipo			Varchar(2) = '01',
    @CodPeriodo		Varchar(6),
    @CodPC			VARCHAR(60) = '',
    @TipoDetalle	VARCHAR(2) = '',
    @TamanoPagina	Integer = 20,
    @NumeroPagina	Integer = 1,
    @EtiquetaPagina	Varchar(20)  = Null Output,
    @Acumulado		Bit = 1,
    @Descripcion	Varchar(1024) = '',
    @Escala			Tinyint	= 0 -- 0 = Mensual, 1 = Semana, 2 = Año

  */
  return await signalGenericRequest(
    PROJECTS_GET_MONTHLY_RES,
    `dbo.S10_06_Tablero_ListarProyectoMensualRecurso '${idCod}', '${type}', '${date}', '${codPc || ''}', '${head}', ${itemsPerPage}, ${pageNumber}, '', ${accumulated}, '${finalSearch}', ${scale}`,
    true
  );
  
}



export const requestSignalProfitCoins = async () => {
  await signalGenericRequest(
    PROFIT_GET_COINS,
    `dbo.S10_06_Moneda_Listar`,
  );
}

export const requestSignalProfitCompanies = async (email: string) => {
	// const {loadingCompanies} = store.getState().profit;
  await signalGenericRequest(
    PROFIT_GET_COMPANIES,
    `dbo.S10_LM_Empresa_ListarPorUsuario '${email}'`,
  );
}

export const requestSignalProfitProjectsByCompany = async (codCompany: string) => {
  return await signalGenericRequest(
    PROFIT_GET_PROJECTS,
    `dbo.S10_LM_Proyecto_ListarPorEmpresa '${codCompany}'`,
  );
}

export const requestSignalProfitPeriods = async (codCompany: string, scale: string) => {
  return await signalGenericRequest(
    PROFIT_GET_PERIODS,
    `dbo.S10_10_Periodo_ListarPorEmpresa '${codCompany}', ${scale}`,
  );
}

export const requestSignalProfitPC = async (codProject: string) => {
  return await signalGenericRequest(
    PROFIT_GET_PC,
    `dbo.S10_06_BI_LucroMargen_ListarPC '${codProject}'`,
  );
}

export const requestSignalProfitByCompanyAndProject = async (codCompany: string, codProject: string, scale: string, periods: string[], codPC: string) => {
  return await signalGenericRequest(
    PROFIT_GET_PROFIT,
    `dbo.S10_06_BI_LucroMargen_Listar '${codCompany}', '${codProject}', ${scale}, '${periods.join('|')}', '${codPC}'`,
  );
}

export const requestSignalBoardProcessStatus = async (tipoTablero: string, codProyecto: string = '') => {
  return await signalGenericRequest(
    BOARD_PROCESS_STATUS,
    `${BOARD_PROCESS_STATUS_SP} '${tipoTablero}', '${codProyecto}'`,
  );
}

export const requestSignalBoardProcessExecute = async (tipoTablero: string, codProyecto: string = '') => {
  return await signalGenericRequest(
    BOARD_PROCESS_EXECUTE,
    `${BOARD_PROCESS_EXECUTE_SP} '${tipoTablero}', '${codProyecto}'`,
  );
}

